import UserAuthenticationModal, {
  UserAuthenticationModalProps,
} from './UserAuthenticationModal';

export default UserAuthenticationModal;
export { UserAuthenticationModalProps };
